<template>
	<base-application :metadataOptions="metadataOptions"></base-application>
</template>
<script>
	import { BaseApplication, getUser, MetadataOptions } from "@ado/base-application";
	export default {
		components: { BaseApplication },
		data() {
			return {
				isLoaded: false,
				metadataOptions: MetadataOptions.Disabled()
			}
		},
		computed: {
			isSignedIn() {
				return getUser().isSignedIn;
			}
		},
		mounted() {
			// race condition gate latch to prevent initial computation of isSignedIn from triggering watcher
			this.$nextTick(() => {
				this.isLoaded = true;
			});
		},
		watch: {
			isSignedIn(newUserIsSignedIn, oldUserIsSignedIn) {
				if (this.isLoaded) {
					if (newUserIsSignedIn != oldUserIsSignedIn) {
						location.reload();
					}
				}
			}
		}
	}
</script>